(function () {
  'use strict';
  if (window.senmitAluminumQuoteInit) {
    window.senmitAluminumQuoteInit(document);
    return;
  }
  var uploaderModule;
  function loadUploader() {
    if (!uploaderModule) {
      uploaderModule = new Promise(function (resolve, reject) {
        var timer;
        function cleanup() {
          clearTimeout(timer);
          window.removeEventListener('senmit:aluminum-uploader-error', fail);
        }
        function fail() {
          cleanup();
          reject(new Error('File uploader could not initialize'));
        }
        if (window.senmitAluminumUploaderError) {
          fail();
          return;
        }
        window.addEventListener('senmit:aluminum-uploader-error', fail, { once: true });
        timer = setTimeout(fail, 20000);
        Promise.all([
          customElements.whenDefined('uc-file-uploader-regular'),
          customElements.whenDefined('uc-upload-ctx-provider')
        ]).then(function () {
          cleanup();
          resolve();
        }, fail);
      });
    }
    return uploaderModule;
  }
  function initializeSuccess(root) {
    var dialog = root.querySelector('[data-adr-success-dialog]');
    if (!dialog || dialog.dataset.adrSuccessBound === 'true') return;
    dialog.dataset.adrSuccessBound = 'true';
    var feedback = root.querySelector('[data-adr-success-feedback]');
    var closeButton = dialog.querySelector('[data-adr-success-close]');
    var message = dialog.querySelector('[data-adr-success-message]');
    if (typeof dialog.showModal !== 'function') {
      if (message && typeof window.alert === 'function') window.alert(message.textContent.trim());
      return;
    }
    function restoreConfirmation() {
      if (feedback) {
        feedback.hidden = false;
        feedback.focus();
      }
    }
    if (closeButton) closeButton.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', restoreConfirmation);
    try {
      dialog.showModal();
      if (feedback) feedback.hidden = true;
      if (closeButton) closeButton.focus();
    } catch (error) {
      // The inline server-confirmed success message remains available.
      restoreConfirmation();
    }
  }
  function initialize(root) {
    initializeSuccess(root);
    var form = root.querySelector('form');
    if (!form || root.dataset.adrQuoteBound === 'true') return;
    root.dataset.adrQuoteBound = 'true';
    var provider = form.querySelector('[data-adr-upload-provider]');
    var hiddenFiles = form.querySelector('[data-adr-upload-files]');
    var statusText = form.querySelector('[data-adr-upload-status]');
    var fallback = form.querySelector('[data-adr-upload-fallback]');
    var button = form.querySelector('button[type="submit"]');
    if (!provider || !hiddenFiles || !statusText || !button) return;
    var originalLabel = button.textContent;
    var state = {};
    var blocked = false;
    function sync(next) {
      state = next || {};
      var all = Array.isArray(state.allEntries) ? state.allEntries.filter(function (entry) { return entry.status !== 'removed'; }) : [];
      var success = Array.isArray(state.successEntries) ? state.successEntries : all.filter(function (entry) { return entry.status === 'success'; });
      var ready = success.filter(function (entry) { return entry && typeof entry.cdnUrl === 'string' && /^https:\/\//i.test(entry.cdnUrl); });
      var total = Math.max(Number(state.totalCount) || 0, all.length, success.length);
      var uploading = state.isUploading || state.status === 'uploading' || Number(state.uploadingCount) > 0 || all.some(function (entry) { return entry.status === 'uploading'; });
      var failed = state.isFailed || state.status === 'failed' || Number(state.failedCount) > 0 || (state.errors && state.errors.length > 0) || all.some(function (entry) { return entry.status === 'failed'; });
      var pending = total > 0 && (ready.length !== total || !(state.isSuccess || state.status === 'success'));
      blocked = Boolean(uploading || failed || pending);
      hiddenFiles.value = ready.map(function (entry) {
        var name = String(entry.name || 'Project file').replace(/[\r\n]/g, ' ');
        return name + ': ' + entry.cdnUrl;
      }).join('\n');
      button.disabled = blocked;
      if (blocked) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
      button.textContent = uploading ? 'Uploading files...' : originalLabel;
      if (failed) {
        statusText.dataset.state = 'error';
        statusText.textContent = 'A file needs attention. Retry or remove any failed files before submitting.';
      } else if (uploading || pending) {
        statusText.dataset.state = 'uploading';
        statusText.textContent = 'Preparing or uploading files. Please wait before submitting.';
      } else if (ready.length) {
        statusText.dataset.state = 'success';
        statusText.textContent = ready.length + (ready.length === 1 ? ' file is ready.' : ' files are ready.') + ' Submit the form below to send their links with your inquiry.';
      } else {
        statusText.dataset.state = '';
        statusText.textContent = 'No files added. Attachments are optional.';
      }
    }
    function readLatest() {
      try {
        if (typeof provider.getAPI === 'function') {
          var api = provider.getAPI();
          if (api && typeof api.getOutputCollectionState === 'function') return api.getOutputCollectionState();
        }
      } catch (error) {
        // Keep the most recent event state while the uploader initializes.
      }
      return state;
    }
    provider.addEventListener('change', function (event) { sync(event.detail); });
    form.addEventListener('submit', function (event) {
      sync(readLatest());
      if (blocked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        statusText.focus();
      }
    }, true);
    loadUploader().then(function () {
      if (!root.isConnected) return;
      sync(readLatest());
    }).catch(function () {
      if (!root.isConnected) return;
      statusText.dataset.state = 'error';
      statusText.textContent = 'The file uploader could not load. Reload the page to try again.';
      if (fallback) fallback.hidden = false;
    });
  }
  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-adr-quote-form]')) initialize(scope);
    scope.querySelectorAll('[data-adr-quote-form]').forEach(initialize);
  }
  window.senmitAluminumQuoteInit = initializeAll;
  initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
